import React from "react";
import { View, StyleSheet } from "react-native";

interface CustomProgressBarProps {
  progress: number;
  chinaTracker?: boolean;
}

const CustomProgressBar = ({
  progress,
  chinaTracker = false,
}: CustomProgressBarProps) => {
  const barWidth = chinaTracker ? "40%" : "80%";
  const marginRight = chinaTracker ? "60%" : "30%";

  return (
    <View style={[styles.container, { marginRight: marginRight }]}>
      <View style={[styles.progressBarBackground, { width: barWidth }]}>
        <View style={[styles.progressBarFill, { width: `${progress}%` }]} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center", // Center horizontally
    justifyContent: "center",
    width: "100%", // Ensure full width so centering works
  },
  progressBarBackground: {
    height: 10,
    borderRadius: 5,
    backgroundColor: "#E0E0E0",
    overflow: "hidden",
  },
  progressBarFill: {
    height: "100%",
    backgroundColor: "#42A5F5",
    borderRadius: 5,
  },
});

export default CustomProgressBar;
